import { useNavigate } from "react-router-dom";
import { getUserInfo, loginApi } from "./auth/Api";
import { useEffect, useState } from "react";
import { useAuth } from "./auth/Authcontext";
import { toast } from 'react-toastify';


export default function Login() {

  const [username ,setUsername] = useState("")
  const [password , setPassword] = useState("")
  const [errorMessage , setErrorMessage] = useState(null)
  const navigate = useNavigate();
  const { login , contextValue,updateUserData , authToken} = useAuth();
  const [btnDisabled , setBtnDisabled] = useState(false)


  useEffect(() => {


    if(authToken){

      navigate("/home");

    }
    

  },[authToken])

  const getuserinfo = () => {
      getUserInfo().then((response) => {


        updateUserData(response.data)

        console.log(response.data)

      })
      .catch(error => console.error(error))
      .finally(() => {});
  }

    const handleSubmit = async (event) => { 

      if(!username && !password){
        toast.error("Username or Password required");

        return;
      }

      setBtnDisabled(true)
      event.preventDefault();

      try{

        contextValue.showLoader();
        contextValue.updateLoaderText("Fetching user details...");


        const response = await loginApi(
          {
            "username": username,
            "password": password ,
            "userType": "Administrator"
          }
        )

        setBtnDisabled(false)
        contextValue.hideLoader()

        if(response.status == 200){

          console.log(response.data.access_token)
          getuserinfo(response.data.access_token)
          

         // console.log("logned in",response.data.access_token)
          login(response.data);
          navigate("/home");
        }

        else {

          toast.error(response.data.message || "Login failed");

          setErrorMessage(response.data.message || "Login failed")
          
          //alert()
        }

       // console.log(response)


      }catch(error){

        console.log(error)
        setBtnDisabled(false)
        contextValue.hideLoader()

        if(error.response.data.message){
          setErrorMessage(error.response.data.message || "Login failed")
          toast.error(error.response.data.message  || "Login failed")
        }else{
          setErrorMessage("Login failed")
          toast.error("Login failed")
        }




        console.log(error)
      }



    }
    return (
      <div className="min-vh-100 d-flex justify-content-center align-items-center bg-primary">
        <div className="bg-white p-5 rounded shadow" style={{ width: '100%', maxWidth: '400px' }}>
          <h2 className="mb-4 text-center">Login</h2>
          <div className="mb-3">
            <input type="text" className="form-control" placeholder="Username"  defaultValue={username}
            
            onChange={(e) => setUsername(e.target.value)}
            />
          </div>
          <div className="mb-3">
            <input type="password" className="form-control" placeholder="Password"  defaultValue={password}
            onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div>
            {
              errorMessage && 
              <div className="mb-4">
                <span className="text-danger">{errorMessage}</span>
              </div>
            }
            
          </div>
          <button disabled={btnDisabled} className="btn btn-primary w-100" onClick={handleSubmit}>Login</button>
        </div>
      </div>
    );
  }